import http from '../versa/http.js';

// Script set-api-host.ps1 atualiza API_BASE; '' = same-origin quando servido pela API
const API_BASE = 'https://sessp.sialwms.com.br';
const AGENT_URL = 'http://localhost:9101';
const HOST = (typeof window !== 'undefined' && window.location.port === '8001') ? '' : API_BASE;
//const HOST = 'http://localhost:8000';	// Dev docker-compose
//const HOST = 'http://localhost:8000';		// Prod

/** Base da API (mesma regra do HOST interno)  -  para fetch direto sem msgbox, ex. banner da Central. */
export function getSialApiHost()
{
	return HOST;
}

const API = {

	call: http,

	/** Base URL da API  -  igual ao HOST interno do m?dulo (vazio em dev :8001, API_BASE em produ??o). */
	HOST,

	// AUTH

	async auth(username, password)
	{
		let endpoint = `${HOST}/auth`;
		// encodeURIComponent: senha com & = + quebrava o corpo (campos a mais / vazios) e podia virar 500/parse errado
		const body = 'username=' + encodeURIComponent(String(username ?? '')) + '&password=' + encodeURIComponent(String(password ?? ''));
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: body
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async request_password(data)
	{
		let endpoint = `${HOST}/auth/requests`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reset_password(data)
	{
		let endpoint = `${HOST}/auth/resets`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// ENDPOINTS

	async list_endpoints(query = '')
	{
		let endpoint = `${HOST}/endpoints${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_endpoint(data)
	{
		let endpoint = `${HOST}/endpoints`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_endpoint(endpoint_id, data)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_endpoint(endpoint_id)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_endpoint(endpoint_id)
	{
		let endpoint = `${HOST}/endpoints/${endpoint_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// GROUPS

	async list_groups(query = '')
	{
		let endpoint = `${HOST}/groups${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_group(data)
	{
		let endpoint = `${HOST}/groups`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_group(group_id, data)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_group(group_id)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_group(group_id)
	{
		let endpoint = `${HOST}/groups/${group_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// USERS

	async list_users(query = '')
	{
		let endpoint = `${HOST}/users${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_user(data)
	{
		let endpoint = `${HOST}/users`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_user(user_id, data)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { 
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_user(user_id)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_user(user_id)
	{
		let endpoint = `${HOST}/users/${user_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOGS

	async list_logs(query = '')
	{
		let endpoint = `${HOST}/logs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_log(log_id)
	{
		let endpoint = `${HOST}/logs/${log_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// INTEGRATION EVENTS (Central de integra??es #MT-6531173)

	async list_integration_events(query = '')
	{
		let endpoint = `${HOST}/integration-events${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async integration_events_entity_alerts(query = '')
	{
		let endpoint = `${HOST}/integration-events/entity-alerts${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_integration_event(integration_event_id)
	{
		let endpoint = `${HOST}/integration-events/${integration_event_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_integration_event(data)
	{
		let endpoint = `${HOST}/integration-events`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async integration_events_summary(hours = 24, stale_minutes = 12)
	{
		let endpoint = `${HOST}/integration-events/summary?hours=${encodeURIComponent(hours)}&stale_minutes=${encodeURIComponent(stale_minutes)}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async get_integration_events_techhub_inbox_debug(inbox_id)
	{
		let endpoint = `${HOST}/integration-events/techhub-inbox/${encodeURIComponent(inbox_id)}/debug`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/**
	 * @param {number} limit  -  lote autom?tico (cron) quando n?o h? inbox_ids
	 * @param {null|{ inbox_ids?: number[], inbox_id?: number }} extra  -  UI: { inbox_ids: [1,2] } ou legado { inbox_id: 742 }
	 */
	async post_integration_events_techhub_process(limit = 200, extra = null)
	{
		let q = `limit=${encodeURIComponent(limit)}`;
		const ex = extra && typeof extra === 'object' ? extra : {};
		if (ex.inbox_id != null && ex.inbox_id !== '')
			q += `&inbox_id=${encodeURIComponent(ex.inbox_id)}`;
		let endpoint = `${HOST}/integration-events/techhub-process?${q}`;
		const ids = Array.isArray(ex.inbox_ids) ? ex.inbox_ids.filter((n) => n != null && String(n).trim() !== '') : [];
		const useBody = ids.length > 0;
		let options = {
			method: 'POST',
			credentials: 'include',
			headers: useBody ? { 'Content-Type': 'application/json' } : {},
			body: useBody ? JSON.stringify({ inbox_ids: ids.map((n) => parseInt(String(n), 10)).filter((n) => !Number.isNaN(n)) }) : undefined,
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_techhub_flush_status(limit = 200)
	{
		let endpoint = `${HOST}/integration-events/techhub-flush-status?limit=${encodeURIComponent(limit)}`;
		let options = { method: 'POST', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_techhub_pull(body = {})
	{
		let endpoint = `${HOST}/integration-events/techhub-pull`;
		let options = {
			method: 'POST',
			body: JSON.stringify(body && typeof body === 'object' ? body : {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async get_integration_events_techhub_runtime_config()
	{
		let endpoint = `${HOST}/integration-events/techhub-runtime-config`;
		let response = await fetch(endpoint, { method: 'GET', credentials: 'include' });
		return response;
	},

	async put_integration_events_techhub_runtime_config(portal_enabled)
	{
		let endpoint = `${HOST}/integration-events/techhub-runtime-config`;
		let options = {
			method: 'PUT',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ portal_enabled: !!portal_enabled }),
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_techhub_list_integrated(body = {})
	{
		let endpoint = `${HOST}/integration-events/techhub-list-integrated`;
		let options = {
			method: 'POST',
			body: JSON.stringify(body && typeof body === 'object' ? body : {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_gsnet_validate(body = {})
	{
		let endpoint = `${HOST}/integration-events/gsnet-entry/validate`;
		let options = {
			method: 'POST',
			body: JSON.stringify(body && typeof body === 'object' ? body : {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_gsnet_send(body = {})
	{
		let endpoint = `${HOST}/integration-events/gsnet-entry/send`;
		let options = {
			method: 'POST',
			body: JSON.stringify(body && typeof body === 'object' ? body : {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async post_integration_events_gsnet_mappings_validate(body = {})
	{
		let endpoint = `${HOST}/integration-events/gsnet-entry/mappings-validate`;
		let options = {
			method: 'POST',
			body: JSON.stringify(body && typeof body === 'object' ? body : {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// CITIES

	async list_cities(query = '')
	{
		let endpoint = `${HOST}/cities${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// COMPANIES

	async list_all_companies(query = '')
	{
		let endpoint = `${HOST}/companies/all${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_companies(query = '')
	{
		let endpoint = `${HOST}/companies${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_company(data)
	{
		let endpoint = `${HOST}/companies`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_company(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// UNITS

	async list_units(query = '')
	{
		let endpoint = `${HOST}/units${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_unit(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/units`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_unit(company_id, unit_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/units/${unit_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_unit(company_id, unit_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/units/${unit_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_unit(company_id, unit_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/units/${unit_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CLASSES

	async list_classes(query = '')
	{
		let endpoint = `${HOST}/classes${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_class(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_class(company_id, class_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_class(company_id, class_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_class(company_id, class_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_class(company_id, class_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/classes/${class_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CATEGORIES
	
	async list_categories(query = '')
	{
		let endpoint = `${HOST}/categories${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_category(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_category(company_id, category_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories/${category_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_category(company_id, category_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories/${category_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_category(company_id, category_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/categories/${category_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// MANUFACTURERS
	
	async list_manufacturers(query = '')
	{
		let endpoint = `${HOST}/manufacturers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_manufacturer(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_manufacturer(company_id, manufacturer_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_manufacturer(company_id, manufacturer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_manufacturer(company_id, manufacturer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/manufacturers/${manufacturer_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PRODUCTS

	async list_products(query = '')
	{
		let endpoint = `${HOST}/products${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_product(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/products`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_product(company_id, product_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_product(company_id, product_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { 
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PRODUCT PACKAGINGS

	async list_product_packagings(query = '')
	{
		// Sob /companies/? para ambientes em que nginx s? proxeia prefixos j? listados (ex.: AWS QA sem /packagings).
		let endpoint = `${HOST}/companies/packagings${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_product_packagings_by_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}/packagings`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Confer?ncia / coletor: GTIN cadastrado na embalagem ? registro da embalagem (incl. product_id). */
	async resolve_packaging_gtin(company_id, gtin)
	{
		const q = new URLSearchParams({ gtin: String(gtin || '').trim() });
		let endpoint = `${HOST}/companies/${company_id}/packagings/resolve-gtin?${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_product_packaging(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_product_packaging(company_id, packaging_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_product_packaging(company_id, packaging_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_product_packaging(company_id, packaging_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_product_packaging(company_id, packaging_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/packagings/${packaging_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// WAREHOUSES

	async list_warehouses(query = '')
	{
		let endpoint = `${HOST}/warehouses${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_warehouse(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_warehouse(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_warehouse(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_warehouse(company_id, warehouse_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_warehouse(company_id, warehouse_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOCATIONS

	async list_locations(query = '')
	{
		let endpoint = `${HOST}/locations${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_location_labels(data)
	{
		let endpoint = `${HOST}/locations/print-labels`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_location(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_location(company_id, warehouse_id, location_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_location(company_id, warehouse_id, location_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_location(company_id, warehouse_id, location_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PAYMENT TERMS

	async list_payment_terms(query = '')
	{
		let endpoint = `${HOST}/payment-terms${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_payment_term(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_payment_term(company_id, payment_term_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_payment_term(company_id, payment_term_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_payment_term(company_id, payment_term_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/payment-terms/${payment_term_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PRICE LISTS

	async list_price_lists(query = '')
	{
		let endpoint = `${HOST}/price-lists${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_price_list(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_price_list(company_id, price_list_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists/${price_list_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_price_list(company_id, price_list_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists/${price_list_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_price_list(company_id, price_list_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/price-lists/${price_list_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// SUPPLIERS

	async list_suppliers(query = '')
	{
		let endpoint = `${HOST}/suppliers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_supplier(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_supplier(company_id, supplier_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers/${supplier_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_supplier(company_id, supplier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers/${supplier_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_supplier(company_id, supplier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/suppliers/${supplier_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CUSTOMERS

	async list_customers(query = '')
	{
		let endpoint = `${HOST}/customers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async count_customers_report(data)
	{
		let endpoint = `${HOST}/customers/count-report`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_customers_report(data)
	{
		let endpoint = `${HOST}/customers/print-report`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_customer(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_customer(company_id, customer_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_customer(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_customer(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CUSTOMER PRICES (tabela de pre?o por cliente)

	async customer_prices_template(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/template`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_import(company_id, customer_id, csv_content)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices/import`;
		let options = {
			method: 'POST',
			body: JSON.stringify({ csv: csv_content }),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_summary(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-prices-summary`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_list(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_replace(company_id, customer_id, prices)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
		let options = {
			method: 'PUT',
			body: JSON.stringify({ prices }),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_prices_delete(company_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/customer-prices`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async customer_price_get(company_id, customer_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/price?product_id=${product_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CUSTOMER DELIVERY ADDRESSES

	/**
	 * Lista endere?os de entrega de um cliente.
	 * @param {string} active_only - se '1', retorna apenas ativos
	 */
	async list_customer_delivery_addresses(company_id, customer_id, active_only = false)
	{
		const q = active_only ? '?active_only=1' : '';
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_customer_delivery_address(company_id, customer_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_customer_delivery_address(company_id, customer_id, address_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses/${address_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_customer_delivery_address(company_id, customer_id, address_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customers/${customer_id}/delivery-addresses/${address_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// CARRIERS

	async list_carriers(query = '')
	{
		let endpoint = `${HOST}/carriers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_carrier(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_carrier(company_id, carrier_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers/${carrier_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_carrier(company_id, carrier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers/${carrier_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_carrier(company_id, carrier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers/${carrier_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOCAIS DE ENTREGA

	async list_delivery_locations(query = '')
	{
		let endpoint = `${HOST}/delivery-locations${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_delivery_location(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/delivery-locations`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_delivery_location(company_id, location_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/delivery-locations/${location_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_delivery_location(company_id, location_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/delivery-locations/${location_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_delivery_location(company_id, location_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/delivery-locations/${location_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_delivery_location(company_id, location_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/delivery-locations/${location_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CAIXAS DO TRANSPORTADOR

	async list_carrier_boxes(query = '')
	{
		let endpoint = `${HOST}/carrier-boxes${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_carrier_box(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/carrier-boxes`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_carrier_box(company_id, box_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/carrier-boxes/${box_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_carrier_box(company_id, box_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/carrier-boxes/${box_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_carrier_box(company_id, box_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/carrier-boxes/${box_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_carrier_boxes_by_carrier(company_id, carrier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/carriers/${carrier_id}/boxes`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_output_carrier_volumes(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/carrier-volumes`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async set_output_carrier_for_volumes(company_id, output_id, carrier_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/carrier-volumes/carrier`;
		let options = {
			method: 'POST',
			body: JSON.stringify({ carrier_id }),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async open_output_carrier_volume(company_id, output_id, carrier_box_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/carrier-volumes`;
		let options = {
			method: 'POST',
			body: JSON.stringify({ carrier_box_id }),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async add_output_carrier_volume_item(company_id, output_id, volume_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/carrier-volumes/${volume_id}/items`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async close_output_carrier_volume(company_id, output_id, volume_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/carrier-volumes/${volume_id}/close`;
		let options = { method: 'POST', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async reopen_output_carrier_volume(company_id, output_id, volume_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/carrier-volumes/${volume_id}/reopen`;
		let options = { method: 'POST', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// ETIQUETAS (modelo ZPL por empresa)

	async list_label_templates(company_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-templates`;
		return await fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async select_label_template(company_id, label_key)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-templates/${encodeURIComponent(label_key)}`;
		return await fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async save_label_template(company_id, label_key, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-templates/${encodeURIComponent(label_key)}`;
		return await fetch(endpoint, {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		});
	},

	async reset_label_template(company_id, label_key)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-templates/${encodeURIComponent(label_key)}`;
		return await fetch(endpoint, { method: 'DELETE', credentials: 'include' });
	},

	async preview_label_template(company_id, label_key, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-templates/${encodeURIComponent(label_key)}/preview`;
		return await fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		});
	},

	async test_print_label_template(company_id, label_key, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-templates/${encodeURIComponent(label_key)}/test-print`;
		return await fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		});
	},

	async select_label_logo(company_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-logo`;
		return await fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async save_label_logo(company_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-logo`;
		return await fetch(endpoint, {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		});
	},

	async delete_label_logo(company_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/label-logo`;
		return await fetch(endpoint, { method: 'DELETE', credentials: 'include' });
	},

	// DEVICES

	async list_devices(query = '')
	{
		let endpoint = `${HOST}/devices${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_device(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_device(company_id, device_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices/${device_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_device(company_id, device_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices/${device_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_device(company_id, device_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/devices/${device_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// CFOPS

	async list_cfops(query = '')
	{
		let endpoint = `${HOST}/cfops${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_class_tribs(query = '')
	{
		let endpoint = `${HOST}/class-tribs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_class_trib(code)
	{
		let endpoint = `${HOST}/class-tribs/${encodeURIComponent(code)}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_cfop(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_cfop(company_id, cfop_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops/${cfop_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_cfop(company_id, cfop_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops/${cfop_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_cfop(company_id, cfop_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops/${cfop_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_cfops_by_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/cfops`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// PROGRAMS

	async list_programs(query = '')
	{
		let endpoint = `${HOST}/programs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_programs_by_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_program(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_program(company_id, program_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs/${program_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_program(company_id, program_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs/${program_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_program(company_id, program_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/programs/${program_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// RECEIPT TYPES (tipo de recebimento  -  pedido de entrada)

	async list_receipt_types(query = '')
	{
		// Sob /companies/? para ambientes em que nginx s? proxeia prefixos j? listados (ex.: AWS QA sem /receipt-types).
		let endpoint = `${HOST}/companies/receipt-types${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_receipt_types_by_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_receipt_type(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_receipt_type(company_id, receipt_type_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_receipt_type(company_id, receipt_type_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_receipt_type(company_id, receipt_type_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/receipt-types/${receipt_type_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},


	// CUSTOMER ROUTES (rotas de cliente  -  Organiza??o)

	async list_customer_routes(query = '')
	{
		let endpoint = `${HOST}/customer-routes${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_customer_routes_by_company(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_customer_route(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_customer_route(company_id, customer_route_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_customer_route(company_id, customer_route_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
		let options = { method: 'PATCH', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_customer_route(company_id, customer_route_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_customer_route(company_id, customer_route_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_customer_routes(query = '', format = 'csv')
	{
		const sep = query && query.includes('?') ? '&' : '?';
		let endpoint = `${HOST}/customer-routes${query || ''}${sep}format=${format}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_customer_routes_by_company(company_id, format = 'csv')
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/export?format=${format}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_customer_route_customers(company_id, customer_route_id, query = '')
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_customer_route_customers(company_id, customer_route_id, format = 'csv')
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers?format=${format}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async link_customer_route_customers(company_id, customer_route_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async unlink_customer_route_customer(company_id, customer_route_id, customer_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}/customers/${customer_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async search_customer_route_available(company_id, customer_route_id, query = '')
	{
		const q = encodeURIComponent(query || '');
		let endpoint = `${HOST}/companies/${company_id}/customer-routes/${customer_route_id}/available-customers?query=${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// INPUT DOCKS (#MT-B2FA396)

	async list_input_docks(query = '')
	{
		let endpoint = `${HOST}/companies/input-docks${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_input_docks_by_company(company_id, query = '')
	{
		let endpoint = `${HOST}/companies/${company_id}/input-docks${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input_dock(company_id, dock_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-docks/${dock_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input_dock(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-docks`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_input_dock(company_id, dock_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-docks/${dock_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_input_dock_disabled(company_id, dock_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-docks/${dock_id}/disabled`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INPUT DOCK SCHEDULING (#MT-B2FA396 Fase 3B)

	async list_input_dock_availability(company_id, query = '')
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-availability${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_input_dock_schedules(company_id, query = '')
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input_dock_schedule(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input_dock_schedule(company_id, schedule_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async cancel_input_dock_schedule(company_id, schedule_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}/cancel`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async complete_input_dock_schedule(company_id, schedule_id, data = {})
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}/complete`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async no_show_input_dock_schedule(company_id, schedule_id, data = {})
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}/no-show`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reschedule_input_dock_schedule(company_id, schedule_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules/${schedule_id}/reschedule`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input_order_dock_schedule(company_id, input_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}/dock-schedule`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_dock_schedule_control(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules/print-control`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_input_dock_schedules_xlsx(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-dock-schedules/export-xlsx`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input_order_dock_schedule(company_id, input_order_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}/dock-schedule`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INPUT ORDERS

	async list_input_orders(query = '')
	{
		// Sob /companies/? para nginx AWS que s? proxeia esse prefixo (mesmo padr?o de receipt-types / packagings).
		let endpoint = `${HOST}/companies/input-orders${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input_order(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_input_order(company_id, input_order_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_input_order(company_id, input_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input_order(company_id, input_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_pending_input_items(company_id, input_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/${input_order_id}/pending`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_order_document(data)
	{
		let endpoint = `${HOST}/input-orders/print-order-document`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INPUTS

	async list_inputs(query = '')
	{
		let endpoint = `${HOST}/inputs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_input(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async inventory_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/inventory`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async putaway_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/putaway`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reverse_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/reverse`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inputs(data)
	{
		let endpoint = `${HOST}/inputs/print-list`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_skus(data)
	{
		let endpoint = `${HOST}/inputs/print-skus`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_xml(data)
	{
		let endpoint = `${HOST}/inputs/print-xml`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_putaway(data)
	{
		let endpoint = `${HOST}/inputs/print-putaway`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_costs(data)
	{
		let endpoint = `${HOST}/inputs/print-costs`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_conference(data)
	{
		let endpoint = `${HOST}/inputs/print-conference`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_details(data)
	{
		let endpoint = `${HOST}/inputs/print-details`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_inputs_csv(data)
	{
		let endpoint = `${HOST}/inputs/export-csv`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async count_inputs_complete_report(data)
	{
		let endpoint = `${HOST}/inputs/print-complete/count`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inputs_complete_report(data)
	{
		let endpoint = `${HOST}/inputs/print-complete`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async count_input_documents_list_report(data)
	{
		let endpoint = `${HOST}/inputs/print-documents-list/count`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_documents_list_report(data)
	{
		let endpoint = `${HOST}/inputs/print-documents-list`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async input_expected_traceability(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/expected-traceability`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async input_conference_divergences(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/conference-divergences`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async reparse_input_xml_rastro(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/reparse-xml-rastro`;
		let options = { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_input_labels(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/print-labels`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async import_xml(data)
	{
		let endpoint = `${HOST}/inputs/import-xml`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// LOTS

	async list_lots(query = '')
	{
		let endpoint = `${HOST}/lots${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_lot(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_lot(company_id, lot_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_lot(company_id, lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_lot(company_id, lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// OUTPUT ORDERS

	async list_output_orders(query = '')
	{
		let endpoint = `${HOST}/output-orders${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async summarize_output_orders_simulated_availability(data)
	{
		let endpoint = `${HOST}/output-orders/simulated-availability-summary`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async search_output_orders(data)
	{
		let endpoint = `${HOST}/output-orders/search`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_output_order(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_output_order(company_id, output_order_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_output_order(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async approve_output_orders_batch(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/approve-batch`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async mark_output_orders_partial_completed_batch(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/mark-partial-completed-batch`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async approve_input_orders_batch(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/approve-batch`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reject_input_orders_batch(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/reject-batch`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_output_order(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_pending_output_items(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}/pending`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async output_order_pending_eligibility(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}/pending-order-eligibility`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_pending_output_order(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}/create-pending-order`;
		let options = {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({})
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_pending_output_orders(data)
	{
		let endpoint = `${HOST}/output-orders/print-pending`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_output_order_document(data)
	{
		let endpoint = `${HOST}/output-orders/print-order-document`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_output_orders_csv(data)
	{
		let endpoint = `${HOST}/output-orders/export-csv`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async upload_output_order(company_id, formData)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/upload`;
		let options = { method: 'POST', body: formData, credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async upload_input_order(company_id, formData)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/upload`;
		let options = { method: 'POST', body: formData, credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async preview_input_order_xml(company_id, formData)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/import-xml/preview`;
		let options = { method: 'POST', body: formData, credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async confirm_input_order_xml(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-orders/import-xml/confirm`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async order_upload_template(company_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/order-upload/template`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// OUTPUTS

	async list_outputs(query = '')
	{
		let endpoint = `${HOST}/outputs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async search_outputs(data)
	{
		let endpoint = `${HOST}/outputs/search`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_output(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_output(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_output(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_output(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_output(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Consulta checkpoint parcial de confer?ncia enviado pelo ColetorPWA (#MT-E4C0633). */
	async get_collector_conference_checkpoint(company_id, output_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/collector-conference-checkpoint`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/** Registra checkpoint parcial de confer?ncia do ColetorPWA (#MT-E4C0633). */
	async create_collector_conference_checkpoint(company_id, output_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/collector-conference-checkpoint`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	/** Confer?ncia de Sa?da Web  -  endpoint dedicado; n?o altera fluxo PUT/PATCH legado do Coletor PWA. */
	async conference_output(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/conference`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/** #MT-9448740  -  meta de volumes + packing list frete r?pido. */
	async get_output_packing_plan(company_id, output_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/packing-plan`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async put_output_packing_plan(company_id, output_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/packing-plan`;
		return fetch(endpoint, {
			method: 'PUT',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data || {}),
		});
	},

	/** Lista diverg?ncias de quantidade registradas na confer?ncia de uma sa?da. */
	async list_output_divergences(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/divergences`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/**
	 * Fase 3  -  Pedido Falta: gera um novo Pedido de Sa?da contendo apenas as
	 * quantidades faltantes de uma confer?ncia parcial.
	 * @param {string} company_id
	 * @param {number} output_order_id  - ID do pedido original (output_order)
	 * @param {{ source_output_id: number, grouping: string }} data
	 */
	async create_shortage_order(company_id, output_order_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}/create-shortage`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// --- Fase 4: Unpicking ----------------------------------------------------

	/**
	 * Solicita unpicking para um item de sa?da.
	 * @param {string} company_id
	 * @param {number} output_id
	 * @param {{ output_item_number: number, quantity: number, reason_code: string, reason_note?: string }} data
	 */
	async request_output_unpick(company_id, output_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/outputs/${output_id}/unpick-request`, {
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
		});
	},

	/**
	 * Aprova uma solicita??o de unpicking.
	 * @param {string} company_id
	 * @param {number} output_id
	 * @param {{ request_id: string, approval_note?: string }} data
	 */
	async approve_output_unpick(company_id, output_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/outputs/${output_id}/unpick-approve`, {
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
		});
	},

	/**
	 * Rejeita uma solicita??o de unpicking.
	 * @param {string} company_id
	 * @param {number} output_id
	 * @param {{ request_id: string, rejection_note?: string }} data
	 */
	async reject_output_unpick(company_id, output_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/outputs/${output_id}/unpick-reject`, {
			method: 'POST',
			body: JSON.stringify(data),
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
		});
	},

	/** Lista todas as solicita??es de unpicking de uma sa?da. */
	async list_output_unpick_requests(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/unpick-requests`;
		let response = await fetch(endpoint, { method: 'GET', credentials: 'include' });
		return response;
	},

	/** #MT-BCE6550  -  resumo de gaps + solicita??es (tela analista). */
	async unpick_treatment_summary(company_id, output_id)
	{
		return fetch(`${HOST}/companies/${company_id}/outputs/${output_id}/unpick-treatment`, {
			method: 'GET',
			credentials: 'include',
		});
	},

	/** #MT-BCE6550  -  Aceitar falta f?sica (R?B ? Separada). */
	async accept_output_unpick(company_id, output_id, data = {})
	{
		return fetch(`${HOST}/companies/${company_id}/outputs/${output_id}/unpick-accept`, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
		});
	},

	/** #MT-BCE6550  -  Rejeitar unpick (volta Separando). */
	async treat_reject_output_unpick(company_id, output_id, data = {})
	{
		return fetch(`${HOST}/companies/${company_id}/outputs/${output_id}/unpick-treat-reject`, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
		});
	},

	/** #MT-BCE6550  -  Substituir lote/posi??o. */
	async substitute_output_unpick(company_id, output_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/outputs/${output_id}/unpick-substitute`, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
		});
	},

	/** Antes do faturamento (status < 70): remove linhas, libera reserva R?L; exige permiss?o do endpoint dedicado. */
	async delete_output_separate_lines(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/delete-separate-lines`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_outputs(data)
	{
		let endpoint = `${HOST}/outputs/create`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async close_outputs(data)
	{
		let endpoint = `${HOST}/outputs/close`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async cancel_outputs(data)
	{
		let endpoint = `${HOST}/outputs/cancel`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async reverse_output(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/reverse`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_output_volumes(data)
	{
		let endpoint = `${HOST}/outputs/list-volumes`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_pick_control(data)
	{
		let endpoint = `${HOST}/outputs/print-pick-control`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_pallets_overturn(data)
	{
		let endpoint = `${HOST}/outputs/print-pallets-overturn`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_picklists(data)
	{
		let endpoint = `${HOST}/outputs/print-picklists`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_picklist_order(data)
	{
		let endpoint = `${HOST}/outputs/print-picklist-order`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_aviso_remessa(data)
	{
		let endpoint = `${HOST}/outputs/print-aviso-remessa`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_conference(data)
	{
		let endpoint = `${HOST}/outputs/print-conference`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_output_details(data)
	{
		let endpoint = `${HOST}/outputs/print-details`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_balance_trace(data)
	{
		let endpoint = `${HOST}/outputs/print-balance-trace`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_output_labels(data)
	{
		let endpoint = `${HOST}/outputs/print-labels`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_output_stage_labels(data)
	{
		let endpoint = `${HOST}/outputs/list-stage-labels`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_output_stage_labels(data)
	{
		let endpoint = `${HOST}/outputs/print-stage-labels`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async sendZplToAgent(zpl, printer, printerKey)
	{
		const hasKey = printerKey != null && String(printerKey).trim() !== '';
		const hasPrinterAddr =
			printer &&
			typeof printer === 'object' &&
			String(printer.address || '').trim() !== '';
		if (!hasKey && !hasPrinterAddr)
		{
			throw new Error(
				'A API n?o retornou impressora (printer_key nem IP). Marque "Usar agente local" e escolha a impressora na lista, ' +
				'ou ajuste o cadastro de Dispositivos. Sem isso o agente usa s? [printers] default no config.ini (risco de imprimir na impressora errada).'
			);
		}
		const endpoint = `${AGENT_URL}/print`;
		const payload = { zpl };
		if (hasKey)
			payload.printer_key = String(printerKey).trim();
		if (printer && typeof printer === 'object')
			payload.printer = printer;
		const options = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload)
		};
		let response;
		try {
			response = await fetch(endpoint, options);
		} catch (e) {
			const msg = e && e.message ? String(e.message) : String(e);
			const netFail = /Failed to fetch|NetworkError|network|load failed|fetch/i.test(msg);
			throw new Error(
				netFail
					? `Print Agent n?o responde em ${AGENT_URL}. Neste PC, inicie o agente (pasta do print-agent: INICIAR.bat ou launch-print-agent.vbs) e tente de novo.`
					: `Falha ao contatar o Print Agent (${AGENT_URL}): ${msg}`
			);
		}
		if (!response.ok) {
			const text = await response.text();
			throw new Error(text || `Agente local (${AGENT_URL}) retornou ${response.status}. Verifique se o agente est? rodando.`);
		}
		return response;
	},

	// STOCKS

	async list_stocks(query = '')
	{
		let endpoint = `${HOST}/stocks${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stock_durability(data)
	{
		let endpoint = `${HOST}/stocks/print-durability`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_stocks_simulated_availability(company_id, query = '')
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/simulated-availability${query || ''}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_picking_wave(company_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async insert_stock(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_stock(company_id, stock_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/${stock_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_stock(company_id, stock_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/${stock_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_stock(company_id, stock_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/${stock_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_stocks_by_input(company_id, input_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}/stocks`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_stocks_by_product(company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/products/${product_id}/stocks`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async change_block_reason(company_id, stock_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/stocks/${stock_id}/block-reason`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async move_stock(company_id, lot_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/lots/${lot_id}/move`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_lot_meta_preview(data)
	{
		let endpoint = `${HOST}/stock-management/lot-meta-preview`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_batch_patch_lots(data)
	{
		let endpoint = `${HOST}/stock-management/batch-patch-lots`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_change_packaging(data)
	{
		let endpoint = `${HOST}/stock-management/change-packaging`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_bulk_move(data)
	{
		let endpoint = `${HOST}/stock-management/bulk-move`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_bulk_block(data)
	{
		let endpoint = `${HOST}/stock-management/bulk-block`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_bulk_unblock(data)
	{
		let endpoint = `${HOST}/stock-management/bulk-unblock`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_split_stock(data)
	{
		let endpoint = `${HOST}/stock-management/split-stock`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async stock_management_unitarize_stock(data)
	{
		let endpoint = `${HOST}/stock-management/unitarize-stock`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Move todo estoque dispon?vel (L) da posi??o para outra (L?L). #MT-8EC3321 */
	async move_location_all_available(company_id, warehouse_id, location_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/move-all-available`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stocks_by_sku(data)
	{
		let endpoint = `${HOST}/stocks/print-by-sku`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stocks_by_lot(data)
	{
		let endpoint = `${HOST}/stocks/print-by-lot`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stocks_by_location(data)
	{
		let endpoint = `${HOST}/stocks/print-by-location`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_stocks_balance_blocks(data)
	{
		let endpoint = `${HOST}/stocks/print-balance-blocks`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_lot_labels(data)
	{
		let endpoint = `${HOST}/stocks/print-lot-labels`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_stocks_csv(data)
	{
		let endpoint = `${HOST}/stocks/export`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/**
	 * Relat?rio de SKUs sem movimenta??o de sa?da em per?odo.
	 * @param {string} company_id - UUID da empresa
	 * @param {Object} params - { date_from, date_to, warehouse_id?, format?, limit?, offset? }
	 */
	async sku_no_output_report(company_id, params)
	{
		const q = new URLSearchParams();
		if (params.format)       q.set('format',       params.format);
		if (params.date_from)    q.set('date_from',    params.date_from);
		if (params.date_to)      q.set('date_to',      params.date_to);
		if (params.warehouse_id) q.set('warehouse_id', params.warehouse_id);
		if (params.limit != null)  q.set('limit',  params.limit);
		if (params.offset != null) q.set('offset', params.offset);
		const endpoint = `${HOST}/companies/${company_id}/reports/sku-no-output?${q.toString()}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/** Relat?rio de sa?das para proje??o de compras (#MT-3786886). */
	async output_purchase_report(company_id, params)
	{
		const q = new URLSearchParams();
		q.set('format', 'csv');
		if (params.date_from)    q.set('date_from',    params.date_from);
		if (params.date_to)      q.set('date_to',      params.date_to);
		if (params.warehouse_id) q.set('warehouse_id', params.warehouse_id);
		const endpoint = `${HOST}/companies/${company_id}/reports/output-purchase?${q.toString()}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	// REPLENISHMENTS

	async list_replenishments(query = '')
	{
		let endpoint = `${HOST}/replenishments${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_replenishment(company_id, warehouse_id, body = null)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments`;
		let payload = body && typeof body === 'object' && Object.keys(body).length ? body : null;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			...(payload ? { body: JSON.stringify(payload) } : {})
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_replenishment(company_id, warehouse_id, replenishment_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_replenishment(company_id, warehouse_id, replenishment_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_replenishment(company_id, warehouse_id, replenishment_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishments/${replenishment_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async close_replenishments(data)
	{
		let endpoint = `${HOST}/replenishments/close`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_replenishment_orders(data)
	{
		let endpoint = `${HOST}/replenishments/print-orders`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_replenishment_rules(query = '')
	{
		let endpoint = `${HOST}/replenishment-rules${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_replenishment_rule(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/replenishment-rules`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_replenishment_rule(company_id, warehouse_id, location_id, product_company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/replenishment-rules/${product_company_id}/${product_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_replenishment_rule(company_id, warehouse_id, location_id, product_company_id, product_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/replenishment-rules/${product_company_id}/${product_id}`;
		let options = {
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_replenishment_rule(company_id, warehouse_id, location_id, product_company_id, product_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/locations/${location_id}/replenishment-rules/${product_company_id}/${product_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// INVENTORIES

	async list_inventories(query = '')
	{
		let endpoint = `${HOST}/inventories${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_inventory(company_id, warehouse_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_inventory(company_id, warehouse_id, inventory_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async check_inventory_item(company_id, warehouse_id, inventory_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/items`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async cancel_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/cancel`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async close_inventory(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/close`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inventory_pending(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-pending`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_inventory_deviation(company_id, warehouse_id, inventory_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/warehouses/${warehouse_id}/inventories/${inventory_id}/print-deviation`;
		let options = { 
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// TRANSACTIONS

	async list_transactions(query = '')
	{
		let endpoint = `${HOST}/transactions${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_transaction(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_transaction(company_id, transaction_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions/${transaction_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_transaction(company_id, transaction_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions/${transaction_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_transaction(company_id, transaction_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/transactions/${transaction_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// BI  -  KARDEX (#MT-1DB4950)
	// Query: product_id, date_from, date_to, lot_id?, cost_mode?, include_disabled?, limit?, offset?
	async kardex_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/kardex${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async kardex_summary(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/kardex/summary${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Kardex anal?tico PDF ou CSV  -  body: product_id, date_from, date_to, lot_id?, cost_mode?, include_disabled?, format: pdf|csv */
	async print_kardex(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/reports/kardex/print`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/** BI  -  estoque anal?tico: query = URLSearchParams ou string com ? (format=json|csv, warehouse_id, program_id, product_id, product_search, lot_search, limit, offset, max_rows) */
	async stock_complete_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/stock-complete${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** BI  -  bloqueios descritivo: query = URLSearchParams (format=json|csv, warehouse_id, program_id, product_id, product_search, lot_search, include_all, limit, offset, max_rows) */
	async stock_blocks_descriptive_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/stock-blocks-descriptive${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** BI  -  Extrato SKU (entrada ? sa?da / lote fab.) #MT-8C58776 */
	async sku_extract_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/sku-extract${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** BI  -  Auditoria (XLSX): payload = { theme: 'input'|'output'|'stock', filters: {...}, confirm_over_limit?: boolean } */
	async audit_report(company_id, payload)
	{
		let endpoint = `${HOST}/companies/${company_id}/reports/audit`;
		let options = {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload || {}),
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/** BI  -  linhas de sa?da: query = URLSearchParams (format=json|csv, date_from*, date_to, include_disabled, output_id, output_order_id, product_id, product_search, limit, offset, max_rows) */
	async output_lines_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/output-lines${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** BI  -  produtividade (#MT-D900606): format=json|csv, activity=picking|conference|both, view=detail|summary, date_from*, user_search, ? */
	async output_productivity_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/output-productivity${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Especial SESSP  -  Gest?o de Faturas (#MT-9B4E512). query: date_from*, date_to, program_id, status, include_canceled, limit, offset */
	async especial_sessp_faturas(company_id, query = '')
	{
		const q = query && !query.startsWith('?') ? `?${query}` : query;
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/faturas${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/** Especial SESSP  -  itens da sa?da no dash de faturas. query: output_id* */
	async especial_sessp_faturas_itens(company_id, query = '')
	{
		const q = query && !query.startsWith('?') ? `?${query}` : query;
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/faturas/itens${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/** Especial SESSP  -  hist?rico de status da sa?da. query: output_id* */
	async especial_sessp_faturas_historico(company_id, query = '')
	{
		const q = query && !query.startsWith('?') ? `?${query}` : query;
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/faturas/historico${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/** Especial SESSP  -  Dose Certa painel. query: status, limit, offset */
	async especial_sessp_dose_certa(company_id, query = '')
	{
		const q = query && !query.startsWith('?') ? `?${query}` : query;
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async especial_sessp_dose_certa_detail(company_id, inbox_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/${inbox_id}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async especial_sessp_dose_certa_saidas_abertas(company_id, query = '')
	{
		const q = query && !query.startsWith('?') ? `?${query}` : query;
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/saidas-abertas${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async especial_sessp_dose_certa_promover(company_id, inbox_id, body = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/${inbox_id}/promover`;
		return fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body || {}),
		});
	},

	async especial_sessp_dose_certa_sem_sorter(company_id, inbox_id, body = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/${inbox_id}/atender-sem-sorter`;
		return fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body || {}),
		});
	},

	async especial_sessp_dose_certa_sorter_resend(company_id, inbox_id, body = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/${inbox_id}/sorter-resend`;
		return fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body || {}),
		});
	},

	async especial_sessp_dose_certa_integrar(company_id, inbox_id, body = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/${inbox_id}/integrar`;
		return fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body || {}),
		});
	},

	async especial_sessp_dose_certa_derrubada(company_id, body = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/derrubada`;
		return fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body || {}),
		});
	},

	async especial_sessp_dose_certa_enviar_sorter(company_id, inbox_id, body = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/${inbox_id}/enviar-sorter`;
		return fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body || {}),
		});
	},

	async especial_sessp_dose_certa_separacao_padrao(company_id, inbox_id, body = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/especial/sessp/dose-certa/${inbox_id}/separacao-padrao`;
		return fetch(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body || {}),
		});
	},

	/** Posi??es  -  cat?logo / ocupa??o: query = URLSearchParams (format=json|csv, warehouse_id, occupancy, ?, limit, offset, max_rows; CSV em blocos: format=csv&limit&offset&csv_no_header=1) */
	async locations_catalog_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/locations-catalog${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Embalagens  -  relat?rio cadastro completo: query = URLSearchParams (format=csv, product_id, level=P|S|T, status=all|active|inactive, max_rows) */
	async product_packagings_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/product-packagings${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async products_general_report(company_id, query = '')
	{
		let q = query && !query.startsWith('?') ? `?${query}` : query;
		let endpoint = `${HOST}/companies/${company_id}/reports/products-general${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	// INVOICES

	async list_invoices(query = '')
	{
		let endpoint = `${HOST}/invoices${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_invoice(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_invoice(company_id, invoice_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices/${invoice_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_invoice(company_id, invoice_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices/${invoice_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_invoice(company_id, invoice_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoices/${invoice_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_invoices(data)
	{
		let endpoint = `${HOST}/invoices/create`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_invoices_xml(data)
	{
		let endpoint = `${HOST}/invoices/update-xml`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_archive(data)
	{
		let endpoint = `${HOST}/invoices/archive`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async inutilizar_invoices(data)
	{
		let endpoint = `${HOST}/invoices/inutilizar`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_iqvia(data)
	{
		let endpoint = `${HOST}/invoices/print-iqvia`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async print_iqvia_excluded(data)
	{
		let endpoint = `${HOST}/invoices/print-iqvia-excluded`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// INVOICE LOTS

	async list_invoice_lots(query = '')
	{
		let endpoint = `${HOST}/invoice-lots${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_invoice_lot(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_invoice_lot(company_id, invoice_lot_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
		let options = { 
			method: 'PUT',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_invoice_lot(company_id, invoice_lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_invoice_lot(company_id, invoice_lot_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/invoice-lots/${invoice_lot_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async create_invoice_lots(data)
	{
		let endpoint = `${HOST}/invoice-lots/create`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async send_invoice_lots(data)
	{
		let endpoint = `${HOST}/invoice-lots/send`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async query_invoice_lots(data)
	{
		let endpoint = `${HOST}/invoice-lots/query`;
		let options = { 
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async nfe_emission_control_count(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/reports/nfe-emission-control/count`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async nfe_emission_control_report(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/reports/nfe-emission-control`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	// CAIXAS DE PICKING (Controle de Caixas no Picking  -  C1/C2)

	/**
	 * Pesquisa global de caixas de picking com filtros.
	 * @param {string} company_id
	 * @param {object} params - { code, seal_code, output_id, status, user_id, date_from, date_to }
	 */
	async search_output_picking_boxes(company_id, params)
	{
		const qs = new URLSearchParams();
		if (params) {
			for (const [k, v] of Object.entries(params))
				if (v !== null && v !== undefined && v !== '') qs.set(k, v);
		}
		const q = qs.toString() ? `?${qs.toString()}` : '';
		const endpoint = `${HOST}/companies/${company_id}/output-picking-boxes${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/**
	 * #MT-7546968  -  pend?ncias de Countback (BLOQUEADO_AUDITORIA).
	 */
	async list_output_countback_pendencies(company_id, params)
	{
		const qs = new URLSearchParams();
		if (params) {
			for (const [k, v] of Object.entries(params))
				if (v !== null && v !== undefined && v !== '') qs.set(k, v);
		}
		const q = qs.toString() ? `?${qs.toString()}` : '';
		const endpoint = `${HOST}/companies/${company_id}/outputs/countback-pendencies${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/**
	 * #MT-699B225  -  evid?ncia de Countback: hist?rico de todas as tentativas.
	 * @param {string} company_id Empresa.
	 * @param {object} params Filtros (status, output_id, order_id, sku, lot, location,
	 *   operator, date_from, date_to, only_pendencies, limit, offset, group=count).
	 */
	async list_output_countbacks(company_id, params)
	{
		const qs = new URLSearchParams();
		if (params) {
			for (const [k, v] of Object.entries(params))
				if (v !== null && v !== undefined && v !== '') qs.set(k, v);
		}
		const q = qs.toString() ? `?${qs.toString()}` : '';
		const endpoint = `${HOST}/companies/${company_id}/outputs/countbacks${q}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async get_output_countback(company_id, countback_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/countbacks/${countback_id}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async release_output_countback(company_id, countback_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/countbacks/${countback_id}/release`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	async release_output_countback_batch(company_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/countbacks/release-batch`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	async cancel_output_countback_batch(company_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/countbacks/cancel-batch`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	async report_output_countbacks(company_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/countbacks/report`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	async submit_output_countback(company_id, output_id, item_ref, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/items/${encodeURIComponent(item_ref)}/countback`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	/**
	 * Lista caixas de uma sa?da espec?fica.
	 */
	async list_output_picking_boxes(company_id, output_id)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/**
	 * Gera relat?rio de caixas de picking (PDF ou CSV).
	 * @param {string} company_id
	 * @param {Object} data  { format, code, seal_code, output_id, status, user_id, date_from, date_to }
	 */
	async report_output_picking_boxes(company_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/output-picking-boxes/report`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	/**
	 * Cria nova caixa de picking para a sa?da.
	 */
	async create_output_picking_box(company_id, output_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	/**
	 * Adiciona ou substitui itens na caixa (UPSERT batch  -  quantidade consolidada por linha).
	 */
	async set_output_picking_box_items(company_id, output_id, box_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes/${box_id}/items`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	/**
	 * Lacra uma caixa de picking.
	 */
	async close_output_picking_box(company_id, output_id, box_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes/${box_id}/close`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	/**
	 * Cancela uma caixa de picking.
	 */
	async cancel_output_picking_box(company_id, output_id, box_id, data)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/picking-boxes/${box_id}/cancel`;
		return fetch(endpoint, {
			method: 'POST',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	// VERSION
	
	async version()
	{
		let endpoint = `${HOST}/version`;
		let response = await fetch(endpoint);
		return response;
	},

	// CENTRAL DE IMPORTA??O

	async import_center_entities()
	{
		let endpoint = `${HOST}/import-center/entities`;
		let options = { method: 'GET', credentials: 'include' };
		return fetch(endpoint, options);
	},

	async import_center_validate(formData)
	{
		let endpoint = `${HOST}/import-center/validate`;
		let options = { method: 'POST', body: formData, credentials: 'include' };
		return fetch(endpoint, options);
	},

	async import_center_import(data)
	{
		let endpoint = `${HOST}/import-center/import`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		return fetch(endpoint, options);
	},

	async import_center_template(entity_key)
	{
		let endpoint = `${HOST}/import-center/template/${entity_key}`;
		let options = { method: 'GET', credentials: 'include' };
		return fetch(endpoint, options);
	},

	// -- INVENT?RIO V2 ------------------------------------------------------

	async list_inventory_sessions(company_id) {
		const qs = company_id ? `?company_id=${encodeURIComponent(company_id)}` : '';
		return fetch(`${HOST}/inventory-sessions${qs}`, { credentials: 'include' });
	},

	async create_inventory_session(data) {
		return fetch(`${HOST}/inventory-sessions`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async select_inventory_session(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}?company_id=${company_id}`, { credentials: 'include' });
	},

	async list_inventory_session_items(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/items?company_id=${company_id}`, { credentials: 'include' });
	},

	async inventory_session_summary(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/summary?company_id=${company_id}`, { credentials: 'include' });
	},

	async list_inventory_item_counts(company_id, session_id, scope_item_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/items/${scope_item_id}/counts?company_id=${company_id}`, { credentials: 'include' });
	},

	async freeze_inventory_session(company_id, session_id, scope_filter) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/freeze`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, scope_filter }),
		});
	},

	async unfreeze_inventory_session(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/unfreeze`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async import_inventory_template(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/import-template`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async import_inventory_spreadsheet(company_id, session_id, rows, filename) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/import`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, rows, filename }),
		});
	},

	async simulate_inventory_close(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/simulate-close`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async print_inventory_simulation(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/print-simulation`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async print_inventory_simulation_by_sku(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/print-simulation-by-sku`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async export_inventory_simulation_by_sku(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/export-simulation-by-sku`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async export_inventory_closure_by_sku(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/export-closure-by-sku`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async print_inventory_progress(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/print-progress`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async print_inventory_divergences(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/print-divergences`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async print_inventory_closure(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/print-closure`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async delete_inventory_count(company_id, session_id, count_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/counts/${count_id}/delete`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async clear_inventory_counts(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/clear-counts`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async close_inventory_session(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/close`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async start_inventory_close_job(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/close/start`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async tick_inventory_close_job(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/close/tick`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async get_inventory_close_job_status(company_id, session_id) {
		const q = encodeURIComponent(company_id);
		return fetch(`${HOST}/inventory-sessions/${session_id}/close/status?company_id=${q}`, {
			method: 'GET', credentials: 'include',
		});
	},

	async cancel_inventory_session(company_id, session_id) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/cancel`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id }),
		});
	},

	async register_inventory_count(company_id, session_id, data) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/counts`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, ...data }),
		});
	},

	async register_inventory_count_web(company_id, session_id, data) {
		return fetch(`${HOST}/inventory-sessions/${session_id}/counts`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, ...data }),
		});
	},

	async list_collector_inventory_sessions(company_id) {
		return fetch(`${HOST}/collector/inventory-sessions?company_id=${company_id}`, { credentials: 'include' });
	},

	async next_collector_inventory_item(company_id, session_id) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/next?company_id=${company_id}`, { credentials: 'include' });
	},

	async find_collector_inventory_items(company_id, session_id, { location_id=null, sku=null, lot_id=null } = {}) {
		const qs = new URLSearchParams();
		qs.set('company_id', company_id);
		if (location_id != null && location_id !== '') qs.set('location_id', location_id);
		if (sku != null && sku !== '') qs.set('sku', sku);
		if (lot_id != null && lot_id !== '') qs.set('lot_id', lot_id);
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/items?${qs.toString()}`, { credentials: 'include' });
	},

	async skip_collector_inventory_item(company_id, session_id, scope_item_id, justification='') {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/items/${scope_item_id}/skip`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, justification }),
		});
	},

	async skip_inventory_item_web(company_id, session_id, scope_item_id, justification='') {
		return fetch(`${HOST}/inventory-sessions/${session_id}/items/${scope_item_id}/skip`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, justification }),
		});
	},

	/** Pr?via / confirma??o  -  encerrar posi??o (falta f?sica 1? rodada). Mesma API do coletor. */
	async inventory_close_location_preview(company_id, session_id, location_code) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/locations/close-preview`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, location_code }),
		});
	},

	async inventory_close_location(company_id, session_id, location_code, idempotency_key = null) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/locations/close`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				company_id,
				location_code,
				origin: 'web',
				idempotency_key: idempotency_key || `web-close-${session_id}-${location_code}-${Date.now()}`,
			}),
		});
	},

	/** Pr?via / confirma??o  -  finalizar achados em posi??o vazia (multi-SKU ? 2? contagem). */
	async inventory_finalize_found_preview(company_id, session_id, location_code) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/locations/finalize-found-preview`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, location_code }),
		});
	},

	async inventory_finalize_found(company_id, session_id, location_code, idempotency_key = null) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/locations/finalize-found`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				company_id,
				location_code,
				origin: 'web',
				idempotency_key: idempotency_key || `web-finalize-${session_id}-${location_code}-${Date.now()}`,
			}),
		});
	},

	/** Encerrar posi??o unificado (falta f?sica e/ou achados). */
	async inventory_complete_location_preview(company_id, session_id, location_code) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/locations/complete-preview`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company_id, location_code }),
		});
	},

	async inventory_complete_location(company_id, session_id, location_code, idempotency_key = null) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/locations/complete`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				company_id,
				location_code,
				origin: 'web',
				idempotency_key: idempotency_key || `web-complete-${session_id}-${location_code}-${Date.now()}`,
			}),
		});
	},

	/** Confirmar falta f?sica na 2?/3? rodada (ap?s encerrar posi??o). */
	async inventory_confirm_shortage(company_id, session_id, location_code, quantity = 0, idempotency_key = null) {
		return fetch(`${HOST}/collector/inventory-sessions/${session_id}/locations/confirm-shortage`, {
			method: 'POST', credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				company_id,
				location_code,
				quantity,
				origin: 'web',
				idempotency_key: idempotency_key || `web-shortage-${session_id}-${location_code}-${Date.now()}`,
			}),
		});
	},

	// DOCA EXPEDI??O (#MT-14DB846)

	async list_dock_expedition(company_id, query = '')
	{
		let endpoint = `${HOST}/companies/${company_id}/dock-expedition/outputs${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_dock_expedition(company_id, output_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/dock-expedition/outputs/${output_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_dock_expedition(company_id, output_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/dock-expedition/outputs/${output_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/** #MT-5CFD821  -  vincular mesma posi??o a v?rias sa?das (output_ids). */
	async link_dock_expedition_batch(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/dock-expedition/link-position`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		return await fetch(endpoint, options);
	},

	async advance_dock_expedition(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/dock-expedition/advance`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/** #MT-0F84944  -  Sa?das Faturadas (70) ? Doca Expedi??o (75). ids=[[company_id,id],...] */
	async send_outputs_to_dock_expedition(data)
	{
		let endpoint = `${HOST}/outputs/send-to-dock-expedition`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		return await fetch(endpoint, options);
	},

	async print_dock_romaneio(company_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/dock-expedition/print-romaneio`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async print_dock_aviso_remessa(company_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/dock-expedition/print-aviso-remessa`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	// --- restaurado do api.js 10/09 (f3fa322) apos BKP 13/09 incompleto ---

	async list_user_session_events(user_id, query = '')
	{
		let endpoint = `${HOST}/users/${user_id}/session-events${query}`;
		let options = { method: 'GET', credentials: 'include' };
		return await fetch(endpoint, options);
	},

	async export_user_session_events(user_id, query = '')
	{
		let endpoint = `${HOST}/users/${user_id}/session-events/export${query}`;
		let options = { method: 'GET', credentials: 'include' };
		return await fetch(endpoint, options);
	},

	async list_user_overtime_requests(query = '')
	{
		let endpoint = `${HOST}/user-overtime-requests${query}`;
		let options = { method: 'GET', credentials: 'include' };
		return await fetch(endpoint, options);
	},

	async create_user_overtime_request(data)
	{
		let endpoint = `${HOST}/user-overtime-requests`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		return await fetch(endpoint, options);
	},

	async decide_user_overtime_request(request_id, data)
	{
		let endpoint = `${HOST}/user-overtime-requests/${request_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		};
		return await fetch(endpoint, options);
	},

	async logout()
	{
		let endpoint = `${HOST}/auth/logout`;
		let options = { method: 'POST', credentials: 'include' };
		return await fetch(endpoint, options);
	},

	async post_integration_events_vendatus_outbox_process(limit = 100)
	{
		let endpoint = `${HOST}/integration-events/vendatus-outbox-process?limit=${encodeURIComponent(limit)}`;
		let options = { method: 'POST', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	/**
	 * Reenvia à Vendatus os avisos que a fila já desistiu (status morto).
	 * @param {number} [limit]
	 * @returns {Promise<Response>}
	 */
	async post_integration_events_vendatus_outbox_retry_dead(limit = 100)
	{
		let endpoint = `${HOST}/integration-events/vendatus-outbox-retry-dead?limit=${encodeURIComponent(limit)}`;
		let options = { method: 'POST', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_input_cancel_reasons(query = '')
	{
		let endpoint = `${HOST}/companies/input-cancel-reasons${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_input_cancel_reasons_by_company(company_id, include_disabled = false)
	{
		const q = include_disabled ? '?include_disabled=1' : '';
		let endpoint = `${HOST}/companies/${company_id}/input-cancel-reasons${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async cancel_inputs_batch(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/cancel-batch`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async insert_input_cancel_reason(company_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-cancel-reasons`;
		let options = { method: 'POST', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_input_cancel_reason(company_id, reason_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-cancel-reasons/${reason_id}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async delete_input_cancel_reason(company_id, reason_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-cancel-reasons/${reason_id}`;
		let options = { method: 'DELETE', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_input_cancel_reason(company_id, reason_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/input-cancel-reasons/${reason_id}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_stock_block_kinds(query = '')
	{
		let endpoint = `${HOST}/companies/stock-block-kinds${query}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async list_stock_block_kinds_by_company(company_id, include_disabled = false)
	{
		const q = include_disabled ? '?include_disabled=1' : '';
		let endpoint = `${HOST}/companies/${company_id}/stock-block-kinds${q}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async update_stock_block_kind(company_id, code, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/stock-block-kinds/${encodeURIComponent(code)}`;
		let options = { method: 'PUT', body: JSON.stringify(data), credentials: 'include', headers: { 'Content-Type': 'application/json' } };
		let response = await fetch(endpoint, options);
		return response;
	},

	async select_stock_block_kind(company_id, code)
	{
		let endpoint = `${HOST}/companies/${company_id}/stock-block-kinds/${encodeURIComponent(code)}`;
		let options = { method: 'GET', credentials: 'include' };
		let response = await fetch(endpoint, options);
		return response;
	},

	async patch_input(company_id, input_id, data)
	{
		let endpoint = `${HOST}/companies/${company_id}/inputs/${input_id}`;
		let options = {
			method: 'PATCH',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async mark_output_order_partial_completed(company_id, output_order_id)
	{
		let endpoint = `${HOST}/companies/${company_id}/output-orders/${output_order_id}/mark-partial-completed`;
		let options = {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({})
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_outputs_csv(data)
	{
		let endpoint = `${HOST}/outputs/export-csv`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	async export_outputs_items_csv(data)
	{
		let endpoint = `${HOST}/outputs/export-items-csv`;
		let options = {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' }
		};
		let response = await fetch(endpoint, options);
		return response;
	},

	/** Tira uma linha da confer?ncia parcial do coletor (#MT-2405833). */
	async drop_collector_conference_checkpoint_item(company_id, output_id, item_number)
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/collector-conference-checkpoint/items/${item_number}`;
		return fetch(endpoint, { method: 'DELETE', credentials: 'include' });
	},

	/** Cancela checkpoint pending  -  gestor liberou reconfer?ncia no coletor. */
	async cancel_collector_conference_checkpoint(company_id, output_id, data = {})
	{
		const endpoint = `${HOST}/companies/${company_id}/outputs/${output_id}/collector-conference-checkpoint`;
		return fetch(endpoint, {
			method: 'DELETE',
			body: JSON.stringify(data || {}),
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
		});
	},

	/**
	 * Controle de movimenta??es  -  posi??es ou Origem?Destino (#MT-D8E2535 / #MT-81A7723).
	 * @param {string} company_id
	 * @param {Object} params - { format, date_from, date_to, warehouse_id?, types?, view?, limit?, offset? }
	 */
	async movement_control_report(company_id, params)
	{
		const q = new URLSearchParams();
		if (params.format)       q.set('format',       params.format);
		if (params.date_from)    q.set('date_from',    params.date_from);
		if (params.date_to)      q.set('date_to',      params.date_to);
		if (params.warehouse_id) q.set('warehouse_id', String(params.warehouse_id));
		if (params.types)        q.set('types',        params.types);
		if (params.view)         q.set('view',         params.view);
		if (params.limit != null)  q.set('limit',  String(params.limit));
		if (params.offset != null) q.set('offset', String(params.offset));
		const endpoint = `${HOST}/companies/${company_id}/reports/movement-control?${q.toString()}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/**
	 * Relat?rio de derrubadas (ondas)  -  Tela / CSV / PDF.
	 * @param {string} company_id
	 * @param {Object} params - { format, date_from, date_to, view?, wave_id?, status?, limit?, offset? }
	 */
	async picking_waves_derrubada_report(company_id, params)
	{
		const q = new URLSearchParams();
		if (params.format)    q.set('format', params.format);
		if (params.date_from) q.set('date_from', params.date_from);
		if (params.date_to)   q.set('date_to', params.date_to);
		if (params.view)      q.set('view', params.view);
		if (params.wave_id)   q.set('wave_id', String(params.wave_id));
		if (params.status)    q.set('status', params.status);
		if (params.limit != null)  q.set('limit', String(params.limit));
		if (params.offset != null) q.set('offset', String(params.offset));
		const endpoint = `${HOST}/companies/${company_id}/reports/picking-waves-derrubada?${q.toString()}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/**
	 * Comercial  -  Relat?rio Notas faturadas - Exclusivo (#MT-57E7612).
	 * @param {string} company_id
	 * @param {Object} params - { format, date_from, date_to, customer_id?, customer_name?, cnpj?, status?, sku?, product_name?, limit?, offset? }
	 */
	/**
	 * Comercial  -  Itens a vencer (#MT-D552104).
	 * @param {string} company_id
	 * @param {Object} params - { format, months_ahead?, program_id?, limit? }
	 */
	async expiring_items_report(company_id, params)
	{
		const q = new URLSearchParams();
		if (params.format)          q.set('format', params.format);
		if (params.months_ahead)    q.set('months_ahead', String(params.months_ahead));
		if (params.program_id)      q.set('program_id', String(params.program_id));
		if (params.limit != null)   q.set('limit', String(params.limit));
		const endpoint = `${HOST}/companies/${company_id}/reports/expiring-items?${q.toString()}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	async invoices_billed_exclusive_report(company_id, params)
	{
		const q = new URLSearchParams();
		if (params.format)         q.set('format', params.format);
		if (params.date_from)      q.set('date_from', params.date_from);
		if (params.date_to)        q.set('date_to', params.date_to);
		if (params.customer_id)    q.set('customer_id', String(params.customer_id));
		if (params.customer_name)  q.set('customer_name', params.customer_name);
		if (params.cnpj)           q.set('cnpj', params.cnpj);
		if (params.status)         q.set('status', params.status);
		if (params.sku)            q.set('sku', params.sku);
		if (params.product_name)   q.set('product_name', params.product_name);
		if (params.portaria_344)   q.set('portaria_344', params.portaria_344);
		if (params.limit != null)  q.set('limit', String(params.limit));
		if (params.offset != null) q.set('offset', String(params.offset));
		const endpoint = `${HOST}/companies/${company_id}/reports/invoices-billed-exclusive?${q.toString()}`;
		return fetch(endpoint, { method: 'GET', credentials: 'include' });
	},

	/** #MT-7740432  -  Ondas de derrubada */
	async list_picking_waves(company_id, query = '')
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves${query}`, {
			method: 'GET', credentials: 'include',
		});
	},

	async select_picking_wave(company_id, wave_id)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/${wave_id}`, {
			method: 'GET', credentials: 'include',
		});
	},

	async preview_picking_wave(company_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/preview`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async simulate_picking_wave(company_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/simulate`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async picking_wave_dashboard(company_id)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/dashboard`, {
			method: 'GET', credentials: 'include',
		});
	},

	async list_picking_wave_forklift_tasks(company_id, query = '')
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/forklift-tasks${query}`, {
			method: 'GET', credentials: 'include',
		});
	},

	async confirm_picking_wave_task(company_id, wave_id, task_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/${wave_id}/forklift-tasks/${task_id}/confirm`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async assign_picking_wave(company_id, wave_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/${wave_id}/assign`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async auto_assign_picking_wave(company_id, wave_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/${wave_id}/auto-assign`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async unassign_picking_wave(company_id, wave_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/${wave_id}/unassign`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async prioritize_picking_wave(company_id, wave_id, data)
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/${wave_id}/prioritize`, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});
	},

	async picking_wave_queue(company_id, wave_id, query = '')
	{
		return fetch(`${HOST}/companies/${company_id}/picking-waves/${wave_id}/picking-queue${query}`, {
			method: 'GET', credentials: 'include',
		});
	},

}

export default API;

